import { AppBar, Box, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import BranchSwitcher from "./BranchSwitcher";

// Top bar: menu button, bank and branch, and an Administrator's branch switch
export default function Header({ onToggleMenu, menuOpen }) {
  const user = JSON.parse(secureLocalStorage.getItem("profile") || "null");
  const branch = user?.results?.branch || "";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ bgcolor: "#28373f", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
    >
      <Toolbar sx={{ gap: 1.5, minHeight: { xs: 56, sm: 60 } }}>
        <Tooltip title={menuOpen ? "Hide menu" : "Show menu"}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label={menuOpen ? "Hide menu" : "Show menu"}
            onClick={onToggleMenu}
          >
            <MenuIcon />
          </IconButton>
        </Tooltip>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            component={Link}
            to="/stock/"
            noWrap
            sx={{
              display: "block",
              color: "#17B859",
              fontWeight: 800,
              fontSize: { xs: 15, sm: 18 },
              textDecoration: "none",
            }}
          >
            Sekyere Community Bank PLC
          </Typography>
          <Typography noWrap sx={{ fontSize: 12, opacity: 0.8, textTransform: "capitalize" }}>
            Stock · {branch}
          </Typography>
        </Box>
        <BranchSwitcher />
      </Toolbar>
    </AppBar>
  );
}
